import React from 'react';
import Slider from 'react-slick';
import { mintWeapon } from '../../web3/SFM-WeaponUtils';
import { weapons } from '../../web3/SFM-WeaponConstants';

// Image Overlay for Weapon Description
import SingleNftToMint from '../NFTCards/SingleNftToMint';
//import * as constants from '../../constants'
import constants from '../../constants';
import { PrevArrow } from '../slider/prevArrow';
import { NextArrow } from '../slider/nextArrow';
import { WeaponsData } from '../../data/weapons';

const mint = async (item) => {
  mintWeapon(item);
};

function WeaponsArea() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    nav: true,
    autoplay: false,
    arrows: true,
    autoplaySpeed: 3000,

    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          Padding: '100px 50px',
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="area-bg-one">
      {/* latest-games-area */}
      <section className="latest-games-area pt-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-8">
              <div className="section-title mb-50">
                <span>LATEST RELEASES</span>
                <h2>
                  Choose <span>Weapons</span>
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <Slider className="latest-games-active slick" {...settings}>
                {WeaponsData.map((item, index) => (
                  <SingleNftToMint
                    key={index}
                    item={item}
                    mint={() => mint(item.category)}
                  />
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WeaponsArea;
